import { isArray, isObject } from "radashi";

export function mergeWithDefaults<T extends Record<string, unknown>>(
  values: Record<string, unknown>,
  defaultValues: T,
): T {
  const merged = {} as Record<string, unknown>;
  const allKeys = new Set([
    ...Object.keys(defaultValues),
    ...Object.keys(values),
  ]);

  for (const key of allKeys) {
    const defaultValue = defaultValues[key];
    const storedValue = values[key];

    if (isArray(defaultValue) && isArray(storedValue)) {
      merged[key] = storedValue.map((item, index) => {
        const defItem = defaultValue[index];
        if (isObject(defItem) && isObject(item)) {
          return mergeWithDefaults(
            item as Record<string, unknown>,
            defItem as Record<string, unknown>,
          );
        }
        return item;
      }) as T[typeof key];
      continue;
    }

    if (isObject(defaultValue) && isObject(storedValue)) {
      // Recursively clean nested objects
      merged[key] = mergeWithDefaults(
        storedValue as Record<string, unknown>,
        defaultValue as Record<string, unknown>,
      ) as T[typeof key];
    } else {
      merged[key] =
        key in values && storedValue !== null
          ? (storedValue as T[typeof key])
          : defaultValue;
    }
  }

  return merged as T;
}
